import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'
import { DEFAULT_LANGUAGE } from '../js/constants'

Vue.use(VueI18n)

/* global contextPath */
/* global showError */
/* global errorLang */

const lang = !showError ? store.state.lang : errorLang

const xmlHttp = new XMLHttpRequest()
xmlHttp.open('GET', contextPath + '/translation/js?lang=' + lang, false)
xmlHttp.send(null)

const translations = xmlHttp.responseText

// TODO: Remove substr after translation controller rework
export default new VueI18n({
  locale: lang, // set locale
  fallbackLocale: DEFAULT_LANGUAGE,
  messages: JSON.parse(translations.substr(17))// set locale messages
})
